import {OpenAPI} from './openapi/core/OpenAPI';

export interface UploadHandle {
  promise: Promise<any>;
  abort: () => void;
}

/**
 * XHR upload progress only covers browser→backend transfer.
 * The backend then forwards to HiDrive which takes additional time.
 * We scale XHR progress to 0–90%, then the caller sees 90% until
 * the server responds (success/error).
 */
const UPLOAD_PHASE_MAX = 90;

export function uploadFileWithProgress(
  file: File,
  dirId: string,
  onProgress: (percent: number, phase: 'uploading' | 'processing') => void
): UploadHandle {
  const xhr = new XMLHttpRequest();

  const promise = new Promise<any>((resolve, reject) => {
    const formData = new FormData();
    formData.append('dir_id', dirId);
    formData.append('file', file);

    const base = OpenAPI.BASE || '';
    xhr.open('POST', `${base}/hausverwaltung/addFileToHausverwaltung`);
    xhr.withCredentials = true;

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const raw = event.loaded / event.total;
        const scaled = Math.round(raw * UPLOAD_PHASE_MAX);
        onProgress(scaled, 'uploading');
      }
    };

    xhr.upload.onload = () => {
      // All bytes sent to backend — now waiting for backend→HiDrive
      onProgress(UPLOAD_PHASE_MAX, 'processing');
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        onProgress(100, 'processing');
        try {
          resolve(JSON.parse(xhr.responseText));
        } catch {
          resolve(xhr.responseText);
        }
      } else {
        let data: any;
        try {
          data = JSON.parse(xhr.responseText);
        } catch {
          data = xhr.responseText;
        }
        reject({status: xhr.status, data});
      }
    };

    xhr.onerror = () => {
      reject({status: 0, data: 'Netzwerkfehler'});
    };

    xhr.onabort = () => {
      reject({status: 0, data: 'Upload abgebrochen'});
    };

    xhr.send(formData);
  });

  return {
    promise,
    abort: () => xhr.abort(),
  };
}
